import { TRPCProvider } from "@/providers/TRPCProvider"
import { Provider } from "@/providers/ThemeProvider"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./app"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider>
      <TRPCProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TRPCProvider>
    </Provider>
  </StrictMode>
)
